import React from 'react';
import { sectionHeadingPropTypes } from './SectionHeadingPropTypes';
import * as styles from './SectionHeading.module.scss';
const SectionHeading = ({
  description,
  heading,
  classname
}) => {
  if (!heading && !description) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${classname || null}`
  }, heading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootHeading
  }, heading), description && /*#__PURE__*/React.createElement("p", {
    className: styles.rootDescription
  }, description));
};
export default SectionHeading;